export default "##### Photos\n---\n- Pulled from Google Maps";